<!--ptw总包与分包分类-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      Training
      <div class="select"
           style="position: absolute; right: 5%; z-index: 9;width: 13%;display: inline-block">
        <el-select v-model="default_tag"
                   placeholder="请选择" popper-class="optionsContent"
                   @change="switch_tag">
          <el-option
            v-for="item in multi_tags"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </h1>
    <div v-if="dataNotNull" key="1" class="trainingDiv"
         style="width: 100%; height: 793px; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;"></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>
    <div class="training_detail" v-show="showflag" id="training_detail">
      <p style="margin-top: 20px; margin-left: 20px; text-align: left">{{ selected_type }}</p>
      <div class="close_img_gentry" @click="detailClose"></div>
      <div class="trainingDiv1" style="margin-top:40px; width: 100%; height: 540px">
        <div class="container1" style="height: 100%"></div>
      </div>
    </div>

    <div class="training_detail1" v-if="detail2_data.length > 0" v-show="showflag1" id="training_detail1">
      <div class="top_container">
        <div class="top_1">{{ selected_con }}</div>
        <div class="top_2">{{ selected_type }}</div>
        <div class="top_1">{{ date_index + 1 }} of {{ detail2_data.length }}</div>
        <div class="close_img_training" @click="detailClose1"></div>
      </div>
      <div class="top_container time_container">
        <div class="time_left" v-show="date_index > 0" @click="showPre"></div>
        <div class="time_left left_nomore" v-show="date_index == 0"></div>
        <div class="time_time">{{ detail2_data[date_index].date }}</div>
        <div class="time_right" v-show="date_index + 1 < detail2_data.length" @click="showNext"></div>
        <div class="time_right right_nomore" v-show="date_index + 1 == detail2_data.length"></div>
      </div>
      <div class="top_container content_container">
        <div class="content_sn">S/N</div>
        <div class="content_p">Participants</div>
        <div class="content_d">Designation</div>
      </div>
      <div class="list_container">
        <div class="top_container content_container list_content"
             v-for="(item, index) in detail2_data[date_index].list">
          <div class="content_sn list_one">{{ index + 1 }}</div>
          <div class="content_p list_one">{{ item.participant }}</div>
          <div class="content_d list_one">{{ item.designation }}</div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id'],
  name: "training",
  data() {
    return {
      my_project_id: this.project_id,
      color: this.$store.state.color.chart_color,
      myChart: null,
      myChart1: null,
      showflag: false,
      showflag1: false,
      name: "training",
      dataNotNull: true,
      typeConList: [],
      detailData: {},
      default_tag: "Daily",
      selected_type: '',
      selected_type_id: '',
      selected_con: '',
      multi_tags: [
        {label: "Monthly", value: "1"},
        {label: "Daily", value: "0"},
        {label: "Acc.", value: "2"},
      ],
      detail2_data: [],
      date_index: 0
    }
  },
  methods: {
    switch_tag(label) {
      this.getData(label)
    },
    init() {
      // this.$root.charts.push(this.myChart)
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    init_chart() {
      let that = this
      this.myChart = echarts.init(document.querySelector('.trainingDiv .container1'))
      this.myChart.setOption({
        tooltip: {
          trigger: 'item',
          // formatter: "{a} <br/>{b}: {c} ({d}%)",
          textStyle: {
            fontSize: 40
          }
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          left: '53%',
          top: '0',
          itemGap: 24,
          itemHeight: '28',
          itemWidth: 80,
          textStyle: {
            color: '#FFF',
            fontSize: '36'
          },
          data: []
        },
        series: [{
          name: 'Training',
          data: [],
          type: 'pie',
          hoverOffset: 5,
          radius: ['45%', '65%'],
          center: ['25%', '50%'],
          label: {
            normal: {
              show: true,
              position: 'inside',
              formatter: '{c}',
              textStyle: {
                fontSize: '36',
              }
            },
            emphasis: {
              show: true,
              textStyle: {
                fontSize: '48',
              }
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },

          itemStyle: {
            normal: {
              color: function (params) {
                return that.color[params.dataIndex]
              }
            },
            //鼠标悬停时：
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)',
              borderWidth: 1
            }
          }
        }],
      })

      // this.myChart.on('click', function (params) {
      //     that.selected_type = params.data.name
      //     that.selected_type_id=params.dataIndex
      //     that.showDetail()
      // })
      this.myChart.on('legendselectchanged', function (params) {
        that.selected_type = params.name
        // that.selected_type_id=params.dataIndex
        that.showDetail()
      })

      this.myChart.showLoading({
        text: '',
        color: '#66CCFF',
        maskColor: 'rgba(255, 255, 255, 0)',
      });
    },
    detailClose() {
      this.showflag = false
      this.showflag1 = false
      this.date_index = 0
      this.detail2_data = []
    },
    detailClose1() {
      this.showflag1 = false
      this.date_index = 0
      this.detail2_data = []
    },
    showSecond() {
      let that = this
      var data = []
      let selected_type_id = that.legends.indexOf(that.selected_type)
      for (let key in that.detailData[selected_type_id]) {
        if (key == that.selected_con) {
          data = that.detailData[selected_type_id][key]
        }
      }
      that.$nextTick(() => {
        that.detail2_data = data
        that.showflag1 = true
      })
    },

    showNext() {
      this.date_index += 1
    },
    showPre() {
      this.date_index -= 1
    },
    showDetail() {
      var that = this
      let tindex = that.legends.indexOf(that.selected_type)
      var datas = that.typeConList[tindex].con_list
      var tags = that.typeConList[tindex].con_tag
      this.showflag = true
      this.$nextTick(() => {
        if (!this.myChart1) {
          this.myChart1 = echarts.init(document.querySelector('.trainingDiv1 .container1'))
          this.myChart1.setOption({
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'none'
              },
              formatter: function (params) {
                return params[0].name + ":" + params[0].value
              },
              textStyle: {
                fontSize: '40'
              }
            },
            grid: {
              left: 220
            },
            xAxis: {
              type: 'value',
              show: false,
              axisLabel: {
                formatter: '{value}'
              }
            },
            yAxis: {
              type: 'category',
              inverse: true,
              data: tags,
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#6CF'
                }
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                margin: 15,
                show: true,
                textStyle: {
                  color: '#333',
                  fontSize: 24
                },
              },
              splitLine: {
                show: false
              }
            },
            series: [
              {
                name: 'Total',
                type: 'bar',
                barWidth: '60%',
                data: datas,
                label: {
                  normal: {
                    show: true,
                    color: '#6cf',
                    position: 'right',
                    fontSize: '25',
                    formatter: function (params) {
                      return params.value
                    }
                  }
                },
                itemStyle: {
                  normal: {
                    color: function (params) {
                      return that.color[params.dataIndex]
                    },
                  }
                },
              }
            ]
          })
          this.myChart1.on('click', function (param) {
            that.selected_con = param.name
            that.showSecond()
          });
        } else {
          this.myChart1.setOption({
            yAxis: {
              data: tags
            },
            series: [{
              data: datas
            }]
          })
        }
      })

    },
    formatWidth(str, width) {
      str += ''
      if (str.length < width)
        return this.formatWidth('0' + str, width)
      else
        return str
    },
    analysisResult(result) {
      var ptwclassifys = []
      var legends = []
      var result1 = []
      var con_tag = []
      var con_list = []
      this.typeConList = []
      this.legends = []
      this.detailData = []
      var cdetailData = {}
      for (var i in result) {
        let con_name = result[i].short_name.substring(0, 13) + '\n' + result[i].short_name.substring(13, result[i].short_name.length)
        let tindex = legends.indexOf(result[i].type_name_en)
        if (tindex < 0) {
          legends.push(result[i].type_name_en)
          let last_index = this.typeConList.length - 1
          if (last_index >= 0) {
            this.typeConList[last_index].con_tag = con_tag
            this.typeConList[last_index].con_list = con_list
            this.detailData[last_index] = cdetailData
          }
          this.typeConList.push({
            con_tag: [],
            con_list: []
          })
          con_tag = []
          con_list = []
          cdetailData = {}
          result1.push({name: result[i].type_name_en, value: 1})
        } else {
          result1[tindex].value += 1
        }
        let train_date = result[i].date
        let cindex = con_tag.indexOf(con_name)
        if (cindex < 0) {
          cdetailData[con_name] = []
          cdetailData[con_name].push({
            date: train_date,
            list: [{
              participant: result[i].user_name,
              designation: result[i].role
            }]
          })
          con_tag.push(con_name)
          con_list.push(1)
        } else {
          con_list[cindex] += 1
          var k = 0
          for (k in cdetailData[con_name]) {
            if (train_date == cdetailData[con_name][k].date) {
              cdetailData[con_name][k].list.push({
                participant: result[i].user_name,
                designation: result[i].role
              })
              break
            }
            k = parseInt(k) + 1
          }
          if (k === cdetailData[con_name].length) {
            cdetailData[con_name].push({
              date: train_date,
              list: [{
                participant: result[i].user_name,
                designation: "Engineer"
              }]
            })
          }
        }
      }
      let last_index = this.typeConList.length - 1
      if (last_index >= 0) {
        this.typeConList[last_index].con_tag = con_tag
        this.typeConList[last_index].con_list = con_list
        this.detailData[last_index] = cdetailData
      }
      this.legends = legends
      return {legends: legends, ptwclassifys: result1}
    },
    getData(period) {
      var that = this
      let postData = {
        project_id: this.my_project_id,
        period: period,
        user: window.localStorage.getItem("token_key"),
        // token: window.localStorage.getItem('token')
        token: "lalala"
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjTrainCon", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        if (errNo == "0") {
          this.dataNotNull = true
          this.$nextTick(() => {
            that.init_chart()
            this.myChart.hideLoading()
            var result = resp.data.result;
            var data = that.analysisResult(result)
            this.myChart.setOption({
              legend: {
                data: data.legends,
                itemGap: 20,
                top: 'middle'
              },
              series: [{
                data: data.ptwclassifys
              }]
            })
          })
        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
    if (this.myChart1) {
      this.myChart1.clear()
    }
  },

  mounted() {
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.init_chart()
    this.getData('0')
  }
}
</script>


<style lang="stylus" rel="stylesheet/stylus">
.training_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 90%;
  height: 80%;
  left: 5%;
  top: 12%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.training_detail1 {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  box-shadow: inset 0px 0px 5px 1px #66CCFF;
  position: absolute;
  width: 96%;
  height: 80%;
  left: 2%;
  top: 10%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
  display flex
  flex-direction column
}

.list_container {
  display flex
  flex-direction column
  width 100%
  max-height 300px
  overflow scroll
}

.top_container {
  width: 100%;
  height: 80px;
  display: flex;
  justify-content center
}

.time_container {
  margin-top 30px
  align-items center
}

.content_container {
  margin-top 20px
  width 90%
  margin-left 5%
}

.list_content {
  margin-top 0
}

.top_1 {
  width 30%;
  height 80px;
  display inline;
  line-height 80px
}

.top_2 {
  width 30%;
  height 80px;
  display inline;
  /*line-height 80px*/
}

.close_img_training {
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  margin-left: 10px;
  margin-top: 20px;
  width: 20px;
  height: 20px;
  display inline;
}

.time_left {
  background-image url("../../assets/left_right.png")
  background-repeat: no-repeat;
  width 40px
  height 40px
  display inline
  transform rotate(180deg)
  margin-top 20px
}

.left_nomore {
  background-image url("../../assets/left_right_unable.png")
}

.time_time {
  width 360px
  height 50px
  text-align center
}

.time_right {
  width 40px
  height 40px
  display inline
  background-image url("../../assets/left_right.png")
  background-repeat: no-repeat;
}

.right_nomore {
  background-image url("../../assets/left_right_unable.png")
}

.content_sn {
  width 10%
  height 60px
  line-height 60px
}

.content_p {
  width 55%
  height 60px
  line-height 60px
}

.content_d {
  width 55%
  height 60px
  line-height 60px
}

.list_one {
  font-size 36px
}
</style>




// WEBPACK FOOTER //
// src/components/safety_manage/training.vue